var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useClipboard } from 'root/src/client/web/hooks/useClipboard';
import React, { useCallback } from 'react';
export const CopyToClipboardBase = (_a) => {
    var { children, text, onCopied } = _a, props = __rest(_a, ["children", "text", "onCopied"]);
    const { writeText } = useClipboard();
    const onClick = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        yield writeText(text);
        if (onCopied) {
            onCopied(event, text);
        }
    }), [text, writeText]);
    return (<button {...props} style={{ border: 'none', background: 'none', cursor: 'pointer', margin: 0, padding: 0 }} onClick={onClick} type="button" data-copy={text}>
			{children}
		</button>);
};
